import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalComponent } from 'app/components/modal/modal.component';
import { ModalService } from 'app/services/modal.service';

@Component({
    selector: 'psm-reauth-modal',
    templateUrl: 'reauthModal.component.html'
})

export class ReauthModalComponent extends ModalComponent<boolean> {

    @Output() public loginSucceeded: EventEmitter<void> = new EventEmitter<void>();

    constructor(modalService: ModalService, router: Router) {
        super(modalService, router);
    }

    public onLoginSucceeded() {
        this.close(true);
    }

    public onCloseClicked() {
        this.close(false);
    }

    protected onNavigation() {
        this.close(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/reauthModal.component.ts